import type { BreadcrumbItem } from "@/contexts/breadcrumb-context";

type BreadcrumbPlaceholder = {
  test: (pathname: string) => boolean;
  items: BreadcrumbItem[];
};

const BREADCRUMB_PLACEHOLDERS: BreadcrumbPlaceholder[] = [
  {
    test: (pathname) => /^\/funnels\/[^/]+/.test(pathname),
    items: [{ label: "Experiences", href: "/funnels" }],
  },
  {
    test: (pathname) => /^\/ai\/[^/]+$/.test(pathname),
    items: [{ label: "Agent", href: "/ai" }],
  },
  {
    test: (pathname) =>
      /^\/ad-accounts\//.test(pathname) && pathname !== "/ad-accounts",
    items: [],
  },
  {
    test: (pathname) => /^\/ai-discovery\/prompts\/[^/]+/.test(pathname),
    items: [{ label: "Prompts", href: "/ai-discovery/prompts" }],
  },
  {
    test: (pathname) => {
      if (!pathname.startsWith("/ai-discovery") || pathname === "/ai-discovery") {
        return false;
      }

      return !/^\/ai-discovery\/prompts\/[^/]+/.test(pathname);
    },
    items: [],
  },
];

export const getBreadcrumbPlaceholder = (pathname: string) =>
  BREADCRUMB_PLACEHOLDERS.find((placeholder) => placeholder.test(pathname));
